import React, { Fragment, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles } from "@mui/styles";

import PrimaryButton from "../ui/buttons/primaryButton";
import Form from "../ui/forms";
import Checkbox from "../ui/forms/fields/checkbox";
import Select from "../ui/forms/fields/select";
import RadioGroup from "../ui/forms/fields/radioGroup";
import CurrencyInput from "../ui/forms/fields/currencyInput";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";

import InfoIcon from "@mui/icons-material/InfoOutlined";
import { useGA4React } from "ga-4-react";

import {
  AchieveByList,
  GoalsList,
  NeedToWithdrawList,
  RiskDescriptionsList,
  RiskProfileTypes,
} from "../../libs/staticData";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FormControlLabel,
  MenuItem,
  Radio,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Collapse,
  Link,
  DialogContentText,
  Grid,
  IconButton,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { PlayCircleOutline } from "@mui/icons-material";
import YouTubePlayer from "../ui/youTubePlayer";
import { Box } from "@mui/system";
import { fundFilterCalculation } from "../../libs/calculations";
import { useSelector, useDispatch } from "react-redux";
import PDFView from "./pdfView";
import { numberToCurrency } from "../../libs/helpers";
import { ErrorMessage } from "@hookform/error-message";
import ContactConsultant from "./contactConsuktant";
import CloseIcon from "@mui/icons-material/Close";
import {
  completeStep,
  resetSteps,
  updateStep,
} from "../../features/stepper.slice";
import {
  getSubmition,
  resetSubmition,
} from "../../features/submition/submition.slice";
import { resetData } from "../../features/data/data.slice";
import { useNavigate } from "react-router-dom";
import { resetUser } from "../../features/user/user.slice";
import { Report } from "../../libs/loggers";

const useStyles = makeStyles((theme) => ({}));

const Row = (props) => {
  const { fund, amounts, isSelected } = props;
  const [selected, setSelected] = useState(false);
  const [openDO, setOpenDO] = useState(false);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));

  const classes = useStyles();
  const funds = useSelector((state) => state.investVehicle.value.funds);

  const validationSchema = yup.object().shape(
    {
      selected: yup.bool(),
      lumpsum: yup.number().when("monthly", {
        is: (monthly) => !monthly || monthly === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .moreThan(
            (fund.minInvestment
              ? fund.minInvestment
              : props.minimums?.lumpsum) - 1,
            `Lump Sum must be more than ${numberToCurrency(
              fund.minInvestment ? fund.minInvestment : props.minimums?.lumpsum,
              0
            )} once off`
          )
          .typeError("Lump Sum must be a number"),
        otherwise: yup
          .number()
          .typeError("Lump Sum must be a number")
          .when("lumpsum", {
            is: (lumpsum) => lumpsum > 0,
            then: yup.number().typeError("Lump Sum must be a number"),
          }),
      }),
      monthly: yup.number().when("lumpsum", {
        is: (lumpsum) => !lumpsum || lumpsum === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .moreThan(
            props.minimums?.monthly - 1,
            `Monthly Contribution must be more than ${numberToCurrency(
              props.minimums?.monthly,
              0
            )} p/m`
          )
          .typeError("Monthly Contribution must be a number"),
        otherwise: yup
          .number()
          .typeError("Monthly Contribution must be a number")
          .when("monthly", {
            is: (monthly) => monthly !== 0,
            then: yup
              .number()
              .typeError("Monthly Contribution must be a number")
              .moreThan(
                props.minimums?.monthly - 1,
                `Monthly Contribution must be more than ${numberToCurrency(
                  props.minimums?.monthly,
                  0
                )} p/m`
              ),
          }),
      }),
    },
    ["lumpsum", "monthly"]
  );

  const {
    control,
    handleSubmit,
    watch,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(validationSchema),
  });

  const cbSelectedWatch = watch("selected");
  useEffect(() => {
    onChange();
  }, [cbSelectedWatch]);

  useEffect(() => {
    if (isSelected) {
      setValue("selected", true);
    }
  }, []);

  const onChange = async () => {
    if (await trigger(["selected", "lumpsum", "monthly"]))
      handleSubmit(onSubmit)();
  };

  const onSubmit = (data) => {
    props.onChange(data);
  };

  const generateSplitRecord = (splitFunds) => {
    let s_result = [];
    for (let i = 0; i < splitFunds.length; i++) {
      const f = funds[funds.findIndex((f) => f.id === splitFunds[i].id)];
      s_result.push(f);
    }

    return (
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        role="checkbox"
        aria-checked={selected}
        tabIndex={-1}
        selected={selected}
      >
        <TableCell>
          <Checkbox
            name="selected"
            color="primary"
            label=""
            control={control}
            onChange={onChange}
          />
        </TableCell>
        <TableCell>
          {s_result.map((s_fund, index) => (
            <Typography key={index} sx={{ pt: 1, pb: 1 }}>
              50%
            </Typography>
          ))}
        </TableCell>
        <TableCell>
          {s_result.map((s_fund, index) => (
            <Typography key={index} sx={{ pt: 1, pb: 1 }}>
              {s_fund.name}
            </Typography>
          ))}
        </TableCell>
        <TableCell>
          {s_result.map((s_fund, index) =>
            s_fund.onePager && !mobile ? (
              <PDFView
                key={index}
                file={s_fund.onePager}
                title="One Pager"
                buttonType={"Icon"}
                icon={InfoIcon}
              />
            ) : s_fund.onePager && mobile ? (
              <Box key={index}>
                <Link href={s_fund.onePager} target="_blank">
                  <InfoIcon color="primary" />
                </Link>
              </Box>
            ) : null
          )}
        </TableCell>
        {!mobile && (
          <>
            <TableCell>
              {s_result.map((s_fund, index) => (
                <Typography key={index} sx={{ pt: 1, pb: 1 }}>
                  {s_fund.time}
                </Typography>
              ))}
            </TableCell>
            <TableCell>
              {s_result.map((s_fund, index) => (
                <Typography key={index} sx={{ pt: 1, pb: 1 }}>
                  {s_fund.assetHoldings}
                </Typography>
              ))}
            </TableCell>
            <TableCell>
              {s_result.map((s_fund, index) => (
                <Typography key={index} sx={{ pt: 1, pb: 1 }}>
                  {s_fund.regionalHoldings}
                </Typography>
              ))}
            </TableCell>
          </>
        )}
      </TableRow>
    );
  };

  return (
    <Fragment>
      {fund.split ? (
        generateSplitRecord(fund.split)
      ) : (
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" } }}
          // onClick={(event) => handleClick(event, fund)}
          role="checkbox"
          aria-checked={selected}
          tabIndex={-1}
          selected={selected}
        >
          <TableCell>
            <Checkbox
              name="selected"
              color="primary"
              label=""
              control={control}
              onChange={onChange}
            />
          </TableCell>
          <TableCell padding="normal">100%</TableCell>
          <TableCell>{fund.name}</TableCell>
          <TableCell padding={"normal"}>
            {fund.onePager && !mobile ? (
              <PDFView
                file={fund.onePager}
                title="One Pager"
                buttonType={"Icon"}
                icon={InfoIcon}
              />
            ) : fund.onePager && mobile ? (
              <Link href={fund.onePager} target="_blank">
                <InfoIcon color="primary" />
              </Link>
            ) : null}
          </TableCell>
          {!mobile && (
            <>
              <TableCell>{fund.time}</TableCell>
              <TableCell>{fund.assetHoldings}</TableCell>
              <TableCell>{fund.regionalHoldings}</TableCell>
            </>
          )}
        </TableRow>
      )}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={watch("selected")} timeout="auto" unmountOnExit>
            <Box
              sx={{ margin: 1, display: "flex" }}
              flexDirection={mobile ? "column" : "row"}
              justifyContent={"space-evenly"}
            >
              <CurrencyInput
                type="number"
                id="lumpsum"
                label="Lump Sum"
                symbol="R"
                error={!!errors.lumpsum}
                helperText={errors?.lumpsum?.message}
                control={control}
                defaultValue={
                  amounts?.lumpsum && amounts.lumpsum > 0 ? amounts.lumpsum : 0
                }
                name="lumpsum"
                className={classes.input}
                onChange={onChange}
              />
              {!fund.disableDebitOrder ? (
                <CurrencyInput
                  control={control}
                  defaultValue={
                    amounts?.debitOrder && amounts.debitOrder > 0
                      ? amounts.debitOrder
                      : 0
                  }
                  name="monthly"
                  className={classes.input}
                  type="number"
                  id="monthly"
                  label="Monthly Contribution"
                  symbol="R"
                  error={!!errors.monthly}
                  helperText={errors?.monthly?.message}
                  onChange={onChange}
                />
              ) : mobile ? (
                <>
                  <IconButton onClick={() => setOpenDO(true)}>
                    <InfoIcon
                      color="primary"
                      sx={{ mr: "8px", fontSize: "1rem" }}
                    />
                    <Typography color="primary" variant={"h6"}>
                      Debit Order
                    </Typography>
                  </IconButton>
                  <Dialog open={openDO} onClose={() => setOpenDO(false)}>
                    <DialogTitle>
                      Debit Order
                      <IconButton
                        aria-label="close"
                        onClick={() => setOpenDO(false)}
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        {fund.deitOrderNote}
                        <Link
                          href="mailto:clientservices@fairtreeinvest.com"
                          sx={{ cursor: "pointer" }}
                        >
                          clientservices@fairtreeinvest.com
                        </Link>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <PrimaryButton
                        variant={"outlined"}
                        onClick={() => setOpenDO(false)}
                      >
                        Close
                      </PrimaryButton>
                    </DialogActions>
                  </Dialog>
                </>
              ) : (
                <Typography sx={{ ml: 3, mr: 3 }}>
                  {fund.deitOrderNote}{" "}
                  <Link
                    href="mailto:clientservices@fairtreeinvest.com"
                    sx={{ cursor: "pointer" }}
                  >
                    clientservices@fairtreeinvest.com
                  </Link>
                </Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

function HelpBasicInvestment(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ga4 = useGA4React();
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDisclaimer, setOpenDisclaimer] = useState(false);
  const [openSpeakToConsultant, setOpenSpeakToConsultant] = useState({
    open: false,
  });
  const totalSteps = 6;
  const [player, setPlayer] = useState(false);
  const [selectedFunds, setSelectedFunds] = useState([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const submitionData = useSelector((state) => state.submition.data);
  const userId = useSelector((state) => state.submition.data?.userId);
  const [qualifyingFunds, setQualifyingFunds] = useState([]);

  const funds = useSelector((state) =>
    state.investVehicle.value.funds.filter((v) => v.useForBasicInvestmentHelp)
  );
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  const vehicle = useSelector((state) => state.data.value.vehicle);
  const stepper = useSelector((state) => state.stepper.value);
  let page = window.location.pathname.replace(/^\/|\/$/g, "");

  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };

  useEffect(() => {
    if (submitionData && submitionData.helpDialog) {
      setActiveStep(submitionData.helpDialog.lastActiveStep);
      setSelectedFunds(submitionData.helpDialog.funds);
      reset(submitionData.helpDialog);
    }
  }, []);

  let ga4React = useGA4React();

  const validationSchema = yup.object().shape(
    {
      goal: yup.string().required("Please select a goal."),
      achieveBy: yup
        .string()
        .required("When do you want to achieve this goal."),
      lumpsum: yup.number().when("debitOrder", {
        is: (debitOrder) => !debitOrder || debitOrder === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .moreThan(
            props.minimums?.lumpsum - 1,
            `Lump Sum must be more than ${numberToCurrency(
              props.minimums?.lumpsum,
              0
            )} once off`
          )
          .typeError("Lump Sum must be a number"),
        otherwise: yup
          .number()
          .typeError("Lump Sum must be a number")
          .when("lumpsum", {
            is: (lumpsum) => lumpsum > 0,
            then: yup.number().typeError("Lump Sum must be a number"),
          }),
      }),
      debitOrder: yup.number().when("lumpsum", {
        is: (lumpsum) => !lumpsum || lumpsum === 0,
        then: yup
          .number()
          .required("Either a Lump Sum or a Monthly Contribution is required")
          .moreThan(
            props.minimums?.monthly - 1,
            `Monthly Contribution must be more than ${numberToCurrency(
              props.minimums?.monthly,
              0
            )} p/m`
          )
          .typeError("Monthly Contribution must be a number"),
        otherwise: yup
          .number()
          .typeError("Monthly Contribution must be a number")
          .when("debitOrder", {
            is: (debitOrder) => debitOrder !== 0,
            then: yup
              .number()
              .typeError("Monthly Contribution must be a number")
              .moreThan(
                props.minimums?.monthly - 1,
                `Monthly Contribution must be more than ${numberToCurrency(
                  props.minimums?.monthly,
                  0
                )} p/m`
              ),
          }),
      }),
      withdrawNeed: yup.string().required("Please select one."),
      riskDesc: yup.string().required("Please select one."),
      riskRelated: yup
        .string()
        .required("Please select the one you relate the most to."),
      riskRelatedScore: yup.number(),
      funds: yup.array().min(1, "Please select at least one fund."),
      acknowledge: yup
        .boolean()
        .default(false)
        .oneOf([true], "Please acknowledge disclaimer to continue."),
    },
    ["lumpsum", "debitOrder"]
  );

  const {
    register,
    handleSubmit,
    reset,
    control,
    trigger,
    watch,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: ["all"],
    resolver: yupResolver(validationSchema),
  });
  useEffect(() => {
    register("riskRelatedScore");
    register("funds");
    register("acknowledge");
  }, []);

  useEffect(() => {
    setValue("funds", selectedFunds, { shouldValidate: true });
  }, [selectedFunds, setValue]);

  const watchScore = Math.round(watch("riskRelatedScore") * 100) / 100;
  const watchLumpsum = watch("lumpsum");
  useEffect(() => {
    const lumpsumValue = getValues("lumpsum");
    const f_funds = funds.filter((f) => {
      if (f.minPoints <= watchScore && f.maxPoints >= watchScore) {
        if (f.minInvestment && f.minInvestment <= lumpsumValue) {
          return f;
        } else if (!f.minInvestment) {
          return f;
        }
      }
    });

    setQualifyingFunds(f_funds);
  }, [watchScore, watchLumpsum]);

  const calculate = () => {
    let achieveByValues = {};
    let withdrawValues = {};
    let riskValues = {};
    let riskProfileValues = {};

    const currentValues = getValues();

    if (currentValues.achieveBy && currentValues.achieveBy !== "") {
      achieveByValues.weight = AchieveByList.weight;
      achieveByValues.points = AchieveByList.types.find(
        (x) => x.desc === currentValues.achieveBy
      ).points;
    }

    if (currentValues.withdrawNeed && currentValues.withdrawNeed !== "") {
      withdrawValues.weight = NeedToWithdrawList.weight;
      withdrawValues.points = NeedToWithdrawList.types.find(
        (x) => x.desc === currentValues.withdrawNeed
      ).points;
    }

    if (currentValues.riskDesc && currentValues.riskDesc !== "") {
      riskValues.weight = RiskDescriptionsList.weight;
      riskValues.points = RiskDescriptionsList.types.find(
        (x) => x.desc === currentValues.riskDesc
      ).points;
    }

    if (currentValues.riskRelated && currentValues.riskRelated !== "") {
      riskProfileValues.weight = RiskProfileTypes.weight;
      riskProfileValues.points = RiskProfileTypes.types.find(
        (x) => x.name === currentValues.riskRelated
      ).points;
    }

    if (
      achieveByValues.weight &&
      withdrawValues.weight &&
      riskValues.weight &&
      riskProfileValues.weight
    ) {
      const result = fundFilterCalculation(
        achieveByValues,
        withdrawValues,
        riskValues,
        riskProfileValues
      );

      setValue("riskRelatedScore", result, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const handleClickOpen = () => {
    if (ga4React && vehicle) {
      ga4React.event("requested_help", `${vehicle}`, "help_me_find_my_fund");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePlayer = () => {
    const eventInfo = {
      action: "view",
      category: "video",
      description: "view video",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        title: "The Five Investment Profile Types",
        videoId: "M5iVIUmqlx8",
        value: "view_video",
      },
    };
    Report(eventInfo, userId, submitionId);
    setPlayer(true);
  };

  const handleClosePlayer = () => {
    setPlayer(false);
  };

  const isLastStep = () => {
    return activeStep === totalSteps - 1;
  };

  const handleNext = async (validate) => {
    const isValid = await trigger(validate);
    const data = await getValues();
    const submit = isLastStep() ? "submit" : "continue";
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: `clicked ${submit}`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: activeStep + 1,
        value: `next`,
      },
    };
    if (isLastStep() && isValid) {
      handleDisclaimer();
    } else {
      if (isValid) {
        calculate();
        Report(eventInfo, userId, submitionId);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        props.onHelpNext({ ...data, lastActiveStep: activeStep });
        clearErrors();
      }
    }
  };

  const handleBack = () => {
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked back",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: activeStep + 1,
        value: `back`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleFundSelect = (data, fund) => {
    let currentFunds = [...selectedFunds];

    const eventInfo = {
      action: "select",
      category: "investment-solution",
      description: "select investment solution",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: "select_investment_solution",
        fund: fund.name,
      },
    };

    Report(eventInfo, userId, submitionId);

    if (!data.selected) {
      const fundIndex = currentFunds.findIndex((f) => f.fund.id === fund.id);
      currentFunds.splice(fundIndex, 1);
    }

    if (data.selected && currentFunds) {
      const fundIndex = currentFunds.findIndex((f) => f.fund.id === fund.id);

      // currentFunds[0] = {
      //   fund,
      //   lumpsum: data.lumpsum,
      //   monthly: data.monthly,
      // };

      if (fundIndex !== -1) {
        currentFunds[fundIndex].lumpsum = data.lumpsum;
        currentFunds[fundIndex].monthly = data.monthly;
      } else {
        currentFunds.push({
          fund,
          lumpsum: data.lumpsum,
          monthly: data.monthly,
        });
      }

      // if (currentFunds.length >= 0) {
      //   currentFunds[fundIndex] = {
      //     fund,
      //     lumpsum: data.lumpsum,
      //     monthly: data.monthly,
      //   };
      // } else {
      //   currentFunds.push({
      //     fund,
      //     lumpsum: data.lumpsum,
      //     monthly: data.monthly,
      //   });
      // }
    }

    setSelectedFunds(currentFunds);
  };

  const onSubmit = (data) => {
    const eventInfo = {
      action: "submit",
      category: "investment-solution",
      description: "submit investment solution",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: "select_investment_solution",
        funds: data.funds,
      },
    };

    Report(eventInfo, userId, submitionId);

    data.formSlug = "basic_unit_trust_invest_help";
    props.onDataSubmit({ ...data, lastActiveStep: activeStep });
    setOpen(false);
  };

  const getAmounts = () => {
    const amounts = {
      lumpsum: getValues("lumpsum"),
      debitOrder: getValues("debitOrder"),
    };

    return amounts;
  };

  const NavButtons = (props) => (
    <Box display="flex" justifyContent={"flex-end"}>
      <Button
        disabled={props.index === 0}
        onClick={handleBack}
        sx={{ mt: 1, mr: 1 }}
      >
        Back
      </Button>
      <PrimaryButton
        onClick={() => handleNext(props.validate)}
        sx={{ mt: 1, mr: 1 }}
      >
        {userId ? "Save & Continue" : "Continue"}
      </PrimaryButton>
    </Box>
  );

  const FinalStepButtons = (props) => (
    <Box display={"flex"} flexDirection={"column"} alignItems={"end"} p={0}>
      <Box mb={2}>
        <Button disabled={props.index === 0} onClick={handleBack}>
          Back
        </Button>
      </Box>
      <Box
        display="flex"
        justifyContent={mobile ? "space-between" : "flex-end"}
        alignItems={"center"}
        flexDirection={"row"}
        mb={2}
      >
        <Typography sx={{ mr: 1 }}>
          I am happy with this Investment Solution choice
        </Typography>
        <PrimaryButton
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pl: 3,
          }}
          onClick={() => handleNext(props.validate)}
        >
          {"Submit"}
        </PrimaryButton>
      </Box>
      <Box
        display="flex"
        justifyContent={mobile ? "space-between" : "flex-end"}
        alignItems={"center"}
        flexDirection={"row"}
      >
        <Typography sx={{ mr: 1 }}>
          I am still uncertain about my Investment Solution choice
        </Typography>
        <PrimaryButton
          sx={{ m: 0 }}
          variant={"outlined"}
          onClick={handleSpeakToConsultant}
        >
          Speak to a consultant
        </PrimaryButton>
      </Box>
      <Box mt={2}>
        <Button size={mobile ? "small" : "default"} onClick={handleStartOver}>
          Start Over
        </Button>
      </Box>
    </Box>
  );

  const handleStartOver = () => {
    setConfirmResetOpen(true);
  };

  const handleCloseReset = () => {
    setConfirmResetOpen(false);
  };

  const handleConfirmReset = () => {
    logEvent(
      "reset",
      stepper.steps[stepper.active].name,
      `Step ${stepper.active}`
    );

    navigate(stepper.steps[0].url);
    dispatch(resetSubmition());
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(resetUser());
    setConfirmResetOpen(false);
  };

  const handleDisclaimer = () => {
    setOpenDisclaimer(true);
  };

  const closeDisclaimer = async () => {
    const isValid = await trigger("acknowledge");
    const eventInfo = {
      action: "click",
      category: "guidance-disclaimer",
      description: `clicked close disclaimer`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `close`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpenDisclaimer(false);
  };

  const acknowledgeDisclaimer = () => {
    setValue("acknowledge", true, { shouldValidate: true });
    const eventInfo = {
      action: "click",
      category: "guidance-disclaimer",
      description: `clicked acknowledge disclaimer`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `acknowledge`,
      },
    };
    Report(eventInfo, userId, submitionId);
    handleSubmit(onSubmit)();
    setOpenDisclaimer(false);
  };

  const handleSpeakToConsultant = () => {
    const eventInfo = {
      action: "click",
      category: "help",
      description: `clicked "I would like to speak to a consultant"`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `help_speak_to_a_consultant`,
      },
    };
    const data = getValues();
    data.formSlug = "basic_unit_trust_invest_help";
    data.fundOptions = qualifyingFunds;

    Report(eventInfo, userId, submitionId);
    setOpenSpeakToConsultant({ open: true, data });
  };

  const setCloseSpeakToConsultant = () => {
    setOpenSpeakToConsultant({ open: false });
  };

  const closeContactConsultant = () => {
    const eventInfo = {
      action: "cancel",
      category: "help",
      description: `cancelled help speak to a consultant`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `cancel_speak_to_a_consultant`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpenSpeakToConsultant({ open: false });
  };

  return (
    <Fragment>
      <Form>
        <Stepper activeStep={activeStep} orientation="vertical">
          <Step>
            <StepLabel>Goals and Achievement</StepLabel>
            <StepContent>
              <Select
                name={"goal"}
                control={control}
                error={!!errors.goal}
                helperText={errors.goal?.message}
                label="What is your investment goal?"
              >
                {GoalsList.map((item, index) => (
                  <MenuItem value={item} key={index}>
                    {item}
                  </MenuItem>
                ))}

                <MenuItem value={"other"}>Other</MenuItem>
              </Select>
              <Select
                name={"achieveBy"}
                control={control}
                error={!!errors.achieveBy}
                helperText={errors.achieveBy?.message}
                label="When do you want to achieve this goal by?"
              >
                {AchieveByList.types.map((item, index) => (
                  <MenuItem value={item.desc} key={index}>
                    {item.desc}
                  </MenuItem>
                ))}
              </Select>
              <NavButtons
                index={0}
                totalSteps={6}
                validate={["goal", "achieveBy"]}
              />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Investing</StepLabel>
            <StepContent>
              <Typography>How much do you want to invest?</Typography>
              <CurrencyInput
                type="number"
                id="lumpsum"
                label="Lump Sum"
                symbol="R"
                error={!!errors.lumpsum}
                helperText={errors?.lumpsum?.message}
                control={control}
                defaultValue={0}
                name="lumpsum"
                className={classes.input}
              />
              <CurrencyInput
                control={control}
                defaultValue={0}
                name="debitOrder"
                className={classes.input}
                type="number"
                id="debitOrder"
                label="Debit Order"
                symbol="R"
                error={!!errors.debitOrder}
                helperText={errors?.debitOrder?.message}
              />
              <NavButtons
                index={1}
                totalSteps={6}
                validate={["lumpsum", "debitOrder"]}
              />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Your need to withdraw</StepLabel>
            <StepContent>
              <Typography>
                Will you be able to stay invested throughout the period you
                selected above?
              </Typography>
              <RadioGroup
                control={control}
                aria-label="withdrawNeed"
                name="withdrawNeed"
                error={!!errors?.withdrawNeed}
                helperText={errors?.withdrawNeed?.message}
                xs={{ margin: 1 }}
              >
                {NeedToWithdrawList.types.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item.desc}
                    control={<Radio />}
                    color="primary"
                    label={item.desc}
                    sx={mobile ? { mt: 1, mb: 1 } : {}}
                  />
                ))}
              </RadioGroup>
              <NavButtons index={2} totalSteps={6} validate={"withdrawNeed"} />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Risk</StepLabel>
            <StepContent>
              <Typography>RISK EXPLANATION WHEN INVESTING:</Typography>
              <Typography>
                Risk can be defined as the possibility of something not turning
                out the way you would have liked or differently to how you
                previously supposed. The 'risk-return trade-off' means: the
                higher the investment's level of risk, the higher the potential
                return and vice versa. This could mean potentially losing some
                of your initial capital invested, but could also mean greater
                potential for growth (as your investment value can move up or
                down). The degree to how much it fluctuates is dependent on the
                asset classes you invest in. When looking at your investment
                options, it's important to consider how much time you have to
                invest, your unique financial situation and how much risk you're
                willing to take on.
              </Typography>
              <Typography>
                When you think of 'risk', what word best describes it for you?
              </Typography>
              <RadioGroup
                control={control}
                aria-label="riskDesc"
                name="riskDesc"
                error={!!errors?.riskDesc}
                helperText={errors?.riskDesc?.message}
                xs={{ margin: 1 }}
              >
                {RiskDescriptionsList.types.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item.desc}
                    control={<Radio />}
                    color="primary"
                    label={item.desc}
                  />
                ))}
              </RadioGroup>
              <NavButtons index={3} totalSteps={6} validate={"riskDesc"} />
            </StepContent>
          </Step>

          <Step>
            <StepLabel>Your Investor Profile</StepLabel>
            <StepContent>
              <Typography>
                Watch this short 5-minute video and tell us who you can relate
                to most?
              </Typography>
              <PrimaryButton
                endIcon={<PlayCircleOutline />}
                onClick={() => handlePlayer()}
              >
                Play Video
              </PrimaryButton>
              <YouTubePlayer
                open={player}
                onClose={() => handleClosePlayer()}
                title={"The Five Investment Profile Types"}
                videoId={"M5iVIUmqlx8"}
              />

              <RadioGroup
                control={control}
                aria-label="riskRelated"
                name="riskRelated"
                error={!!errors?.riskRelated}
                helperText={errors?.riskRelated?.message}
                xs={{ margin: 1 }}
              >
                {!mobile ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Withdrawing</TableCell>
                        <TableCell>Total Savings</TableCell>
                        <TableCell>Investment Goal</TableCell>
                        <TableCell>Risk Appetite</TableCell>
                        <TableCell>Portfolio</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {RiskProfileTypes.types.map((item, key) => (
                        <TableRow key={key}>
                          <TableCell width="200px">
                            <FormControlLabel
                              value={item.name}
                              control={<Radio />}
                              color="primary"
                              label={item.name}
                            />
                          </TableCell>
                          <TableCell>{item.withdrawing}</TableCell>
                          <TableCell>{item.totalSavings}</TableCell>
                          <TableCell>{item.investmentGoal}</TableCell>
                          <TableCell>{item.riskAppetite}</TableCell>
                          <TableCell>{item.portfolio}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  RiskProfileTypes.types.map((item, key) => (
                    <FormControlLabel
                      value={item.name}
                      control={<Radio />}
                      color="primary"
                      label={item.name}
                    />
                  ))
                )}
              </RadioGroup>
              <NavButtons index={4} totalSteps={6} validate={"riskRelated"} />
            </StepContent>
          </Step>

          <Step sx={{ p: 0 }}>
            <StepLabel>Fund Selection </StepLabel>
            <StepContent>
              <Table
                size="small"
                padding={mobile ? "none" : "normal"}
                sx={{ mt: 1, mb: 2 }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="subtitle2"></Typography>
                    </TableCell>
                    <TableCell padding="normal">
                      <Typography variant="subtitle2">%</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle2">
                        Investment Solution
                      </Typography>
                    </TableCell>
                    <TableCell></TableCell>
                    {!mobile && (
                      <>
                        <TableCell>
                          <Typography variant="subtitle2">Time</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="subtitle2">
                            Asset Holdings
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="subtitle2">
                            Regional Holdings
                          </Typography>
                        </TableCell>{" "}
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {qualifyingFunds.map((fund, index) => (
                    <Row
                      key={index}
                      fund={fund}
                      onChange={(data) => handleFundSelect(data, fund)}
                      minimums={props.minimums || null}
                      amounts={getAmounts()}
                      isSelected={selectedFunds.some(
                        (item) =>
                          item.fund.name === fund.name &&
                          item.fund.id === fund.id
                      )}
                    />
                  ))}
                </TableBody>
              </Table>
              <Box>
                {isLastStep() && (
                  <ErrorMessage
                    errors={errors}
                    name="funds"
                    render={({ message }) => (
                      <Typography color="error">{message}</Typography>
                    )}
                  />
                )}
              </Box>
              <Box display="flex" justifyContent="flex-end">
                <ErrorMessage
                  errors={errors}
                  name="acknowledge"
                  render={({ message }) => (
                    <Typography color="error">{message}</Typography>
                  )}
                />
              </Box>
              <FinalStepButtons index={5} totalSteps={6} validate={"funds"} />
            </StepContent>
          </Step>
        </Stepper>
      </Form>

      <Dialog open={openDisclaimer} onClose={closeDisclaimer}>
        <DialogTitle>Disclaimer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            I acknowledge that this tool is a factual filter of published
            information relevant to each investment solution's fact sheet. It
            does not make a recommendation or render advice to an investor, but
            merely provides factual information. For advice on the suitability
            of these products to the investor's financial goals and objectives,
            we strongly recommend consulting an approved financial advisor.
            Please note the disclosures relevant to each product displayed on
            this page as published on their fact sheets. Fairtree Asset
            Management is an authorised financial services provider (FSP 25917).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <PrimaryButton onClick={closeDisclaimer} color="primary">
            Close
          </PrimaryButton>
          <PrimaryButton onClick={acknowledgeDisclaimer} color="primary">
            Acknowledge
          </PrimaryButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmResetOpen}
        onClose={handleCloseReset}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Start Over?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to start over?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReset}>Cancel</Button>
          <Button onClick={handleConfirmReset} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <ContactConsultant
        title="Speak to a consultant"
        subTitle={""}
        open={openSpeakToConsultant.open}
        data={openSpeakToConsultant.data}
        onClose={closeContactConsultant}
        setCloseSpeakToConsultant={setCloseSpeakToConsultant}
      />
    </Fragment>
  );
}

export default HelpBasicInvestment;
